import { now as serverNow } from '~/models/clock'
import { addDays, formatDateValue, startOfTodayJst } from '~/models/dateTime'

/**
 * 日断面タブ (AC-PSM-002 / 005)。本 slice は 当日 / 翌日 の 2 値のみ
 * (Design Note Decision 11。翌々日以降は本画面の scope 外)。
 */
export type TargetDaySegment = 'today' | 'tomorrow'

/** タブの表示順 (= AccessibleSegmentedControl の options 順)。 */
export const TARGET_DAY_SEGMENTS: readonly TargetDaySegment[] = [
  'today',
  'tomorrow',
]

/**
 * 対象日 = `clock.now()` の JST 暦日 (当日)、またはその翌日 (Decision 11)。
 *
 * caseId (ワークフロー連動) があっても対象日はロックしない — spec §5 は
 * 読み取り専用のみを要求し、日付ロックは要求しない (Decision 11 の棄却案参照)。
 */
export function resolveTargetDate(
  segment: TargetDaySegment,
  now: Date = serverNow(),
): Date {
  const today = startOfTodayJst(now)
  return segment === 'tomorrow' ? addDays(today, 1) : today
}

/**
 * 日断面タブに添える対象日 (AC-PSM-002)。日本語は `M/D` (例: 10/6)、英語は
 * `english-ui-text-guide.md` の日付形式 `YYYY-MM-DD`。
 *
 * `targetDate` は集約 RPC の request に載せたカレンダー日 (`resolveTargetDate`
 * の戻り値) をそのまま受け取り、ここで日付を計算し直さない (spec「画面側で別に
 * 計算しない」)。
 */
export function formatTargetDateLabel(
  targetDate: Date,
  isEnglish: boolean,
): string {
  return isEnglish
    ? formatDateValue(targetDate)
    : `${targetDate.getMonth() + 1}/${targetDate.getDate()}`
}
